<template>
  <header>
    <div class="header">
      <div class="header__inner">
        <div class="header__row J_headerRow">
          <div class="header__nav">
            <div class="header__nav-items--left">
              <div class="header__company">
                <img src="https://www.honor.com/content/dam/honor/common/logo/honor-logo-black.svg" class="header__logo" />
                <div class="header__company-info">
                  <div class="header__company-name--cn">荣耀安全应急响应中心</div>
                  <div class="header__company-name--en">Honor Security Response Center</div>
                </div>
                <div class="header__button--right"><i class="iconfont icon-yingyongzhongxin header__icon-fenlei" @click="openNavItems"></i></div>
              </div>
              <ul role="menubar" class="header__links J__headerLinks">
                <li class="header__link-item">
                  <router-link class="header__router-link" to="/home" exact> 首页 </router-link>
                </li>
                <li class="header__link-item">
                  <router-link class="header__router-link" to="/report" exact>提交漏洞 </router-link>
                </li>
                <li class="header__link-item">
                  <router-link class="header__router-link" to="/ranking" exact>英雄榜 </router-link>
                </li>
                <!-- <li class="xui-menu-item">
                              <span>英雄榜</span>
                          </li>
                          <li class="xui-menu-item">
                              <router-link to="/program">奖励计划
                              </router-link>
                          </li> -->
                <li class="header__link-item">
                  <router-link class="header__router-link" to="/announcement">公告 </router-link>
                </li>
                <!-- <li class="xui-menu-item">
                <router-link to="/securityUpdates">安全更新 </router-link>
              </li> -->
                <li class="header__link-item">
                  <router-link class="header__router-link" to="/aboutUs">关于我们 </router-link>
                </li>
                <li class="header__link-item">
                  <router-link class="header__router-link is-hidden J_userCenter" to="/usercenter">个人中心 </router-link>
                </li>
                <li class="header__link-item">
                  <a class="header__router-link is-hidden J__loginOutButton" href="javascript: void(0);" @click="handleCommand('out')">退出登录</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="header__user">
            <a id="hwlogin" class="header__login-button J__loginButton" href="javascript: void(0);" @click="loginHandle">登录</a>
            <xui-dropdown class="header__user-select is-hidden J_headerUserSelect" :trigger="PcEnd ? 'hover' : 'click'" @command="handleCommand">
              <div class="header__user-info">
                <div class="header__user-account">
                  <span class="header__user-name">{{ user.displayName }}</span>
                </div>
                <div class="header__user-portrait">
                  <template v-if="user.headPictureUrl">
                    <img class="header__user-pic" :src="'https://' + this.$baseU + '.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=' + user.headPictureUrl" />
                    <span v-if="unReadSiteMsgCount && unReadSiteMsgCount > 0" class="header__msg-count">{{ unReadSiteMsgCount }}</span>
                  </template>
                  <template v-else>
                    <i class="iconfont icon-bianzubeifen header__user-pic--default"></i>
                  </template>
                </div>
              </div>
              <xui-dropdown-menu slot="dropdown">
                <xui-dropdown-item default-actived command="info" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/modify_userinfo-icon.png" />
                  <span>个人资料</span>
                </xui-dropdown-item>

                <xui-dropdown-item command="infoId" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/authenticate-icon.png" />
                  <span>身份认证</span>
                </xui-dropdown-item>

                <xui-dropdown-item command="report" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/my_vulnerability-icon.png" />
                  <span>我的漏洞</span>
                  <span v-if="unReadBbsCount && unReadBbsCount > 0" class="header__msg-count header__msg-count--drowdown">{{ unReadBbsCount }}</span>
                </xui-dropdown-item>

                <xui-dropdown-item command="message" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/msg_center-icon.png" />
                  <span>消息中心</span>
                  <span v-if="unReadMsgListCount && unReadMsgListCount > 0" class="header__msg-count  header__msg-count--drowdown">{{ unReadMsgListCount }}</span>
                </xui-dropdown-item>
                <xui-dropdown-item command="teamMenu" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/teamPic.png" />
                  <span>团队菜单</span>
                </xui-dropdown-item>

                <xui-dropdown-item command="out" class="header__user-select-item">
                  <img class="header__user-select-img" src="../images/logout-icon.png" />
                  <span>退出登录</span>
                </xui-dropdown-item>
              </xui-dropdown-menu>
            </xui-dropdown>
          </div>
        </div>
      </div>
      <xui-dialog v-if="isEffect" title="失效提醒" append-to-body="true" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isEffect" width="30%" @close="isEffect = false">
        <span>您的账号已经失效，请联系管理员</span>
        <span slot="footer" class="dialog-footer" center>
          <xui-button type="primary" size="bigger" @click="isEffect = false">关闭</xui-button>
        </span>
      </xui-dialog>
    </div>
  </header>
</template>

<script>
import { v4 } from 'uuid';
import store from '../store/index';
import { mapState } from 'vuex';
let windowResizeFnTimer = null;

export default {
  name: 'HomeHeader',
  props: {
    actioinHome: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount', 'unReadSiteMsgCount'])
  },
  data() {
    return {
      PcEnd: false,
      isEffect: false,
      isEffectStaus: false,
      isLogin: false,
      user: {
        // displayName: '测试名称',
        displayName: global.userInfo && global.userInfo.displayName,
        headPictureUrl: '',
        imgSrc: null
      },
      isShowNavItems: false
    };
  },
  metaInfo:
    window.location.host === 'security.honor.com'
      ? {
          title: '荣耀安全应急响应中心',
          meta: [
            { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' },
            { name: 'client_id', content: '210902310' },
            { name: 'login_channel', content: '30000000' },
            { name: 'req_client_type', content: '30' },
            { name: 'redirect_uri', content: 'https://security.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/login' },
            { name: 'scope', content: 'openid profile' }
          ]
        }
      : window.location.host === 'hsrc-sit.test.honor.com'
      ? {
          title: '荣耀安全应急响应中心',
          meta: [
            { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' },
            { name: 'client_id', content: '210900017' },
            { name: 'login_channel', content: '30000000' },
            { name: 'req_client_type', content: '30' },
            { name: 'redirect_uri', content: 'https://hsrc-sit.test.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/login' },
            { name: 'scope', content: 'openid profile' }
          ]
        }
      : {
          title: '荣耀安全应急响应中心',
          meta: [
            { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' },
            { name: 'client_id', content: '210900017' },
            { name: 'login_channel', content: '30000000' },
            { name: 'req_client_type', content: '30' },
            { name: 'redirect_uri', content: 'https://hsrc-uat.test.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/login' },
            { name: 'scope', content: 'openid profile' }
          ]
        },
  watch: {
    global: {
      handler: function() {
        console.log(global.userInfo.displayName, 'global.userInfo.displayName');
      }
    },
    immediate: true,
    $route() {
      const docEleWidth = this.getDocEleWidth();
      if (docEleWidth > 980) {
        this.setHeaderLinksFlex();
        this.setLoginOutButtonHidden();
        this.setUserCenterHidden();

        if (this.isLogin) {
          this.setHeaderUserSelectVisible();
        } else {
          this.setHeaderUserSelectHidden();
        }
        this.setHeaderHeightLow();
      } else {
        this.setHeaderLinksHidden()
        if (this.isLogin) {
          this.setLoginOutButtonVisble();
          this.setUserCenterVisible();
        } else {
          this.setloginButtonVisible();
          this.setUserCenterHidden();
        }
        this.setHeaderUserSelectHidden();
        this.setHeaderHeightHigh();
      }

      this.setHeaderHidden()
    },
    isLogin() {
      const docEleWidth = this.getDocEleWidth();
      if (docEleWidth > 980) {
        if (this.isLogin) {
          this.setHeaderUserSelectVisible();
          this.setloginButtonHidden();
        } else {
           this.setHeaderUserSelectHidden()
        }
      } else {
        if (this.isLogin) {
          this.setLoginOutButtonVisble();
          this.setloginButtonHidden();
          this.setUserCenterVisible();
        } else {
          this.setLoginOutButtonHidden();
          this.setloginButtonVisible()
          this.setUserCenterHidden();
        }
        this.setHeaderUserSelectHidden();
      }
    }
  },
  created: function() {
    const sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      //跳转移动端页面
      this.PcEnd = false;
    } else {
      //跳转pc端页面
      this.PcEnd = true;
    }
    // 每个接口调用前，都要先获取x-csrf-token，然后加在header里
    // this.getCSRF()
  },
  beforeMount: function() {
    window.removeEventListener('resize', this.windowResizeFn);
  },
  mounted: function() {
    this.$bus.$on('send', this.setmsgcount);
    setTimeout(() => {
      // console.log('Header文件中的Token-accessToken: ', this && this.$cookies && this.$cookies.get('accessToken'))
      // 登录成功时，返回链接会带上src
      if (window.location.pathname && window.location.pathname.indexOf('src') > -1) {
        this.getUserInfo();
      }
    }, 10);
    window.addEventListener('resize', this.windowResizeFn);
  },
  methods: {
    setmsgcount(count) {
      store.commit('setUnReadSiteMsgCount', count);
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
          .then(res => {
            this.$nextTick(function() {
              window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
              // eslint-disable-next-line no-undef
            });
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleCommand: function(command) {
      if (command === 'info') {
        this.$router.push({ path: '/usercenter/info' });
      } else if (command === 'infoId') {
        this.$router.push({ path: '/usercenter/idinfo' });
      } else if (command === 'report') {
        this.$router.push({ path: '/usercenter/report' });
      } else if (command === 'message') {
        this.$router.push({ path: '/usercenter/sitemsg' });
      } else if (command === 'teamMenu') {
        this.$router.push({ path: '/usercenter/teamMenu' });
      } else if (command === 'out') {
        this.userLogout();
      } else if (command === 'loginOff') {
        this.userLogOff();
      }
    },
    userLogOff() {
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.$confirm(`您确定注销该账户吗？`, '请确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        confirmButtonHighlight: true
      }).then(() => {
        this.$http
          .get(`vul/hsrc/vul/report/services/user/logout`, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res && res.status === 200) {
              this.$router.push({ path: '/' });
            } else {
              this.$message.error(res && res.data && res.data.message);
            }
          })
          .catch(error => {});
      });
    },
    setCookie(c_name, value, expire) {
      const date = new Date();
      date.setSeconds(date.getSeconds() + expire);
      document.cookie = c_name + '=' + escape(value) + '; expires=' + date.toGMTString();
    },
    loginHandle: function() {
      if (this.isEffectStaus) {
        this.isEffect = true;
        return;
      }
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    getUserInfo: function() {
      const that = this;
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount);
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount);
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount);
              this.isLogin = true;
              global.userInfo = res.data.data;
              that.userInfo = res.data.data;
              this.user.displayName = global.userInfo.displayName;
              global.this = this;
              if (res.data.data.headPictureUrl) {
                that.user.headPictureUrl = res.data.data.headPictureUrl;
              }
              // 登陆状态时，获取CSRF
              this.getCSRF();
            } else {
              this.isLogin = false;
              // eslint-disable-next-line no-undef
            }
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isEffectStaus = true;
            }
          });
      });
    },
    userLogout: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/servlet/userLogout')
          .then(res => {
            if (res.status === 200 && res.data && res.data.data) {
              const outUrl =
                window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/connect/v2/logout' : 'https://hnoauth-login-test-drcn.cloud.honor.com/connect/v2/logout';
              const redirectUrl = outUrl + '?response_type=token&access_token=' + encodeURIComponent(res.data.data) + '&next=' + encodeURIComponent('https://' + this.$baseU + '.honor.com/src/');
              window.location.href = redirectUrl;
              console.log('退出接口userLogout返回成功，res.status是200！');
            } else {
              console.log('退出接口userLogout返回失败，res.status不是200！');
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    openNavItems() {
      if (document.querySelector('.J_headerRow').style.height !== '120px') {
        this.setHeaderLinksHidden()
        this.setHeaderHeightHigh();
        this.setHeaderHidden();
      } else {
        this.setHeaderHeightAuto();
        this.setHeaderVisible();
        this.setHeaderLinksFlex();
        document.querySelector('.J_headerRow').style.boxShadow = '0 1px 5px 0px var(--src-box-shadow-color-default)';
      }
      this.setHeaderUserSelectHidden();
    },
    windowResizeFn() {
      clearTimeout(windowResizeFnTimer);
      windowResizeFnTimer = setTimeout(() => {
        const docEleWidth = this.getDocEleWidth();
        if (docEleWidth > 980) {
          this.setHeaderLinksFlex();
          this.setLoginOutButtonHidden();
          this.setUserCenterHidden();
          if (this.isLogin) {
            this.setHeaderUserSelectVisible();
          }
          this.setHeaderHeightLow()
        } else {
          if (this.isLogin) {
            this.setLoginOutButtonVisble();
            this.setUserCenterVisible();
          } else {
            this.setloginButtonVisible()
          }

          this.setHeaderLinksHidden();
          this.setHeaderUserSelectHidden();
          this.setHeaderHeightHigh();
          // if (document.querySelector('.J__headerLinks').style.display === 'flex') {
          //   document.querySelector('.J__headerLinks').style.display = 'none';
          //   document.querySelector('.J__loginButton').style.display = 'none';
          // }
        }

        document.querySelector('.J_headerRow').style.boxShadow = 'none';
        this.setHeaderHidden();
      }, 10);
    },
    getDocEleWidth() {
      return document.documentElement.clientWidth;
    },
    setHeaderHeightHigh () {
      document.querySelector('.J_headerRow').style.height = '120px';
    },
    setHeaderHeightLow () {
      document.querySelector('.J_headerRow').style.height = '66px';
    },
    setHeaderHeightAuto () {
      document.querySelector('.J_headerRow').style.height = 'auto';
    },
    setHeaderHidden () {
      document.querySelector('.J_headerRow').style.overflow = 'hidden';    
    },
    setHeaderVisible () {
      document.querySelector('.J_headerRow').style.overflow = 'visible';  
    },
    setHeaderLinksFlex () {
       document.querySelector('.J__headerLinks').style.display = 'flex';
    },
    setHeaderLinksHidden () {
      document.querySelector('.J__headerLinks').style.display = 'none';  
    },
    setLoginOutButtonHidden () {
      document.querySelector('.J__loginOutButton').style.display = 'none';
    },
    setLoginOutButtonVisble () {
      document.querySelector('.J__loginOutButton').style.display = 'inline-block';
    },
    setUserCenterHidden () {
      document.querySelector('.J_userCenter').style.display = 'none';
    },
    setUserCenterVisible () {
      document.querySelector('.J_userCenter').style.display = 'inline-block';
    },
    setHeaderUserSelectHidden () {
      document.querySelector('.J_headerUserSelect').style.display = 'none';
    },
    setHeaderUserSelectVisible () {
       document.querySelector('.J_headerUserSelect').style.display = 'inline-block';
    },
    setloginButtonVisible () {
      document.querySelector('.J__loginButton').style.display = 'inline-block';
    },
    setloginButtonHidden(){
      document.querySelector('.J__loginButton').style.display = 'none';
    }
  }
};
</script>

<style lang="less" scoped>
@import '../global/variable';
.header {
  position: relative;
  z-index: 1999;
  height: 66px;
  background-color: var(--src-text-color-white);
}

.header__inner {
  position: fixed;
  left: 0;
  right: 0;
  height: 66px;
  background-color: var(--src-text-color-white);
  box-shadow: 0 1px 5px 0px var(--src-box-shadow-color-default), 0 1px 5px 0 var(--src-box-shadow-color-default);
}

.header__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  .pageMaxWidth();
  padding-top: 16px;
  padding-bottom: 16px;
  margin: 0 auto;
  background-color: var(--src-text-color-white);
  overflow: hidden;
}

.header__nav {
  display: flex;
  align-items: center;
}

.header__logo {
  height: 23px;
}

.header__company-info {
  margin-left: 10px;
  white-space: nowrap;
}

.header__company-name--cn {
  font-size: var(--src--text-size-small);
  color: var(--src-color-primary-dark1);
  font-weight: 400;
}

.header__company-name--en {
  font-size: var(--src--text-size-smallest);
  color: var(--src-color-primary-dark1);
  font-weight: 400;
  transform: scale(0.8);
  transform-origin: 0 0;
}

.header__links {
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
}

.header__router-link {
  position: relative;
  font-size: var(--src--text-size-large);
  padding: 5px;
  margin-left: 42px;
  white-space: nowrap;
  user-select: none;
  &.is-hidden {
    display: none
  }
  &:hover {
    opacity: 0.75;
  }
}

@media only screen and (max-width: 1030px) {
  .header__router-link {
    margin-left: 35px;
  }
}

@media only screen and (max-width: 1000px) {
  .header__router-link {
    margin-left: 30px;
  }
}

.header__router-link.is-active {
  color: var(--src-color-primary-dark1);
}

.header__login-button {
  width: 64px;
  height: 26px;
  border: 1px solid var(--src-color-primary-dark1);
  border-radius: 13px;
  font-size: var(--src--text-size-default);
  color: var(--src-color-primary-dark1);
  text-align: center;
  line-height: 24px;
}

.header__user-info {
  position: relative;
  display: flex;
  align-items: center;
}

.header__user-portrait {
  position: relative;
  width: 27px;
  height: 27px;
  border-radius: 50%;
}

.header__user-pic--default {
  font-size: 27px;
}

.header__msg-count {
  position: absolute;
  left: 23px;
  top: -10px;
  height: 15px;
  line-height: 15px;
  padding: 0 4px;
  background-color: var(--src-bg-color-red-light1);
  font-size: 12px;
  color: var(--src-text-color-white);
  border-radius: 7px;
  max-width: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header__user-name {
  display: inline-block;
  max-width: 100px;
  margin: 0 10px;
  font-size: var(--src--text-size-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header__user-account {
  display: flex;
  align-items: center;
}

.header__user-pic {
  width: 100%;
  height: 100%;
}

.header__user-select {
  padding-right: 10px;
  &.is-hidden{
    display: none;
  }
}

.header__user-select-item {
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 146px;
  font-size: 14px;
  &:not(.is-disabled).active {
    color: #333 !important;
  }
}

.header__user-select-img {
  width: 20px;
  margin-right: 10px;
}

.header__msg-count--drowdown {
  right: 16px;
  left: auto;
  top: 2px;
}

.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}

//20221114 导航适配手机端
.header__nav-items--left {
  display: flex;
  align-items: center;
}

.header__company {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__button--right {
  display: none;
  font-size: 22px;
}

@media only screen and (max-width: 980px) {
  .header {
    height: 120px;
  }

  .header__inner {
    height: 120px;
  }

  .header__row {
    height: 120px;
  }

  .header__row,
  .header__links,
  .header__nav-items--left {
    display: block;
    width: 100%;
  }

  .header__row {
    padding: 0;
    overflow: visible;
  }

  .header__company {
    height: 120px;
    padding: 0px 80px;
    box-shadow: 0 1px 5px 0px var(--src-box-shadow-color-default), 0 1px 5px 0 var(--src-box-shadow-color-default);
  }

  .header__button--right {
    display: block;
  }

  .header__login-button {
    width: 100%;
    height: 80px;
    line-height: 80px;
    padding-left: 30px;
    border: none;
    font-size: var(--src--text-size-large-extra9);
    text-align: left;
    color: var(--src-color-secondary-light1);
  }

  .header__icon-fenlei {
    padding: 20px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: var(--src--text-size-large-extra4);
    cursor: pointer;
  }

  .header__links {
    display: none;
    margin: 0;
  }

  .header__link-item {
    width: 100%;
  }

  .header__router-link {
    width: 100%;
    height: 80px;
    line-height: 80px;
    margin: 0;
    padding: 0 0 0 30px;
    text-align: left;
    font-size: var(--src--text-size-large-extra9);
  }

  .header__company-name--cn {
    font-size: var(--src--text-size-large-extra10);
  }

  .header__company-name--en {
    font-size: var(--src--text-size-large-extra3);
  }
}

@media only screen and (min-width: 981px) {
  .header__links {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue